import { render } from "./BigText.vue?vue&type=template&id=5784036d&ts=true"
import script from "./BigText.vue?vue&type=script&lang=ts"
export * from "./BigText.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__